export default {
    allocationOptions: [
        {
            memory: "3.6运存",
            speedUp: "8核",
            stockpile: "44G总储存",
            value: "0",
        },
        {
            memory: "3.7运存",
            speedUp: "8核",
            stockpile: "88G总储存",
            value: "1",
        },
        {
            memory: "3.8运存",
            speedUp: "8核",
            stockpile: "128G总储存",
            value: "2",
        },
        {
            memory: "3.9运存",
            speedUp: "8核",
            stockpile: "256G总储存",
            value: "3",
        },
    ],
    deviceIconOptions: [
        {
            vipName: "VIP",
            vipCode: "VIP1",
            deviceVersionCode: "V7",
            deviceType: "SV7",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo8.png"),
        },
        {
            vipName: "GVIP",
            vipCode: "VIP2",
            deviceVersionCode: "V7",
            deviceType: "G7",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo10.png"),
        },
        {
            vipName: "KVIP",
            vipCode: "VIP3",
            deviceVersionCode: "K7",
            deviceType: "K7",
            deviceIcon: require("@/assets/icons/changwananzhuo8.png"),
        },
        {
            vipName: "XVIP",
            vipCode: "VIP4",
            deviceVersionCode: "V7",
            deviceType: "X7",
            deviceIcon: require("@/assets/icons/changwananzhuo10.png"),
        },
        {
            vipName: "VIP",
            vipCode: "VIP1",
            deviceVersionCode: "V9",
            deviceType: "SV9",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo8.png"),
        },
        {
            vipName: "GVIP",
            vipCode: "VIP2",
            deviceVersionCode: "V9",
            deviceType: "G9",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo10.png"),
        },
        {
            vipName: "KVIP",
            vipCode: "VIP3",
            deviceVersionCode: "V9",
            deviceType: "K9",
            deviceIcon: require("@/assets/icons/changwananzhuo8.png"),
        },
        {
            vipName: "XVIP",
            vipCode: "VIP4",
            deviceVersionCode: "V9",
            deviceType: "X9",
            deviceIcon: require("@/assets/icons/changwananzhuo10.png"),
        },
        {
            vipName: "VIP",
            vipCode: "VIP1",
            deviceVersionCode: "V10",
            deviceType: "SV10",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo8.png"),
        },
        {
            vipName: "GVIP",
            vipCode: "VIP2",
            deviceVersionCode: "V10",
            deviceType: "V10",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo10.png"),
        },
        {
            vipName: "KVIP",
            vipCode: "VIP3",
            deviceVersionCode: "V10",
            deviceType: "V10",
            deviceIcon: require("@/assets/icons/changwananzhuo8.png"),
        },
        {
            vipName: "XVIP",
            vipCode: "VIP4",
            deviceVersionCode: "V10",
            deviceType: "V10",
            deviceIcon: require("@/assets/icons/changwananzhuo10.png"),
        },
        {
            vipName: "VIP",
            vipCode: "VIP1",
            deviceVersionCode: "V11",
            deviceType: "SV11",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo8.png"),
        },
        {
            vipName: "GVIP",
            vipCode: "VIP2",
            deviceVersionCode: "V11",
            deviceType: "G11",
            deviceIcon: require("@/assets/icons/biaozhunanzhuo10.png"),
        },
        {
            vipName: "KVIP",
            vipCode: "VIP3",
            deviceVersionCode: "V11",
            deviceType: "K11",
            deviceIcon: require("@/assets/icons/changwananzhuo8.png"),
        },
        {
            vipName: "XVIP",
            vipCode: "VIP4",
            deviceVersionCode: "V11",
            deviceType: "X11",
            deviceIcon: require("@/assets/icons/changwananzhuo10.png"),
        },
    ],
}